import request from "@/utils/request.js";
import { kudasaiChristmas2 } from "./config.js";
import _ from "lodash";

/**
 * 获取转盘奖励列表
 * @param {*} params
 */
export const getRewardList = () => {
  return request.get(kudasaiChristmas2.reward_list);
};

/**
 * 获取抽奖结果
 * @param {*} params
 */
 export const GetRewardClaim = () => {
    return request.get(kudasaiChristmas2.reward_claim);
};
  /**
 * 获取抽奖结果
 * @param {*} params
 */
 export const GetProps = () => {
    return request.get(kudasaiChristmas2.props);
  };

/**
 * 获取活动时间
 * @param {*} params
 */
export const GetCountDown = () => {
  return request.get(kudasaiChristmas2.reward_time);
};
